import { render, staticRenderFns } from "./GroupOrder.vue?vue&type=template&id=3b8c3927&scoped=true"
import script from "./GroupOrder.vue?vue&type=script&lang=js"
export * from "./GroupOrder.vue?vue&type=script&lang=js"
import style1 from "./GroupOrder.vue?vue&type=style&index=1&id=3b8c3927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c3927",
  null
  
)

export default component.exports